import classnames from 'classnames'
import React from 'react'
import { APPS_ADJUST_URL } from '../../parameters'
import { TAG_BLOCK_AUTOPROMO } from '../analytics/analytics.tagids.constants'
import analyticsConstants from '../analytics/analytics.constants'
import RectangleActionButton, {
  COLOR_GREEN,
  SIZE_MEDIUM
} from '../genericComponents/buttons/RectangleActionButton'
import TagActionLink from '../genericComponents/TagActionLink'
import { withFrenchSite } from '../i18n/i18nSite'
import journeyIcon from './assets/journey.svg'
import s from './AutoPromoPE.less'

const AutoPromoPE = ({ className }) => {
  return (
    <div className={classnames(s.wrapper, className)}>
      <div className={s.infos}>
        <img src={journeyIcon} alt="" width={110} height={110} />
        <div className={s.content}>
          <span>{'Retrouvez vos trajets favoris en un coup d’œil sur l’application Mappy !'}</span>
          <div>
            <TagActionLink
              href={APPS_ADJUST_URL}
              nofollow={true}
              targetBlank={true}
              type={TAG_BLOCK_AUTOPROMO}
              tagInfo={{
                area: analyticsConstants.autopromo.area.main
              }}
            >
              <RectangleActionButton label={"Installer l'App"} color={COLOR_GREEN} size={SIZE_MEDIUM} />
            </TagActionLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withFrenchSite(AutoPromoPE)
